module.exports = __webpack_public_path__ + "assets/whatsapp-business-chat.b096ba35.svg";